import React,{ PureComponent } from 'react'
import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';

/**
 *  E图标
 * size 尺寸：宽度 高度
 * color  默认黑色 透明背景 black, white ：白色透明背景
 *
 **/
class IconE extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
    }
    static defaultProps = {
        size:14,
        color:"#333"
    };
    setIcon =()=>{
        const { size,color } = this.props;
        return(<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 25 24" fill="none">
            <path d="M20.4299 6.17999L20.4245 2H10.5617C8.30811 2 6.70574 2.47709 5.75728 3.42857C4.80883 4.38276 4.33325 5.99024 4.33325 8.25102V15.7246C4.33325 17.9854 4.81153 19.5956 5.76539 20.5579C6.71925 21.5202 8.31892 22 10.5644 22H20.4272V17.7929C20.4272 17.7929 10.4131 17.7929 10.4077 17.7929C9.32682 17.7929 8.427 16.9119 8.4216 15.814C8.41619 14.6945 9.32411 13.9951 10.4077 13.9951C11.8155 13.9951 18.833 13.9924 20.4272 13.9924V9.77989C20.4272 9.77989 11.0886 9.77717 10.0321 9.77446C9.11875 9.69314 8.40268 8.89618 8.40268 7.95825C8.40268 6.96612 9.20522 6.15831 10.1942 6.16102C10.6049 6.16102 20.4299 6.17999 20.4299 6.17999Z"
                  fill={color}
                  fillOpacity="0.89"/>
        </svg>);
    }
    /**
     * 点击事件
     */
    onClick=()=>{
        if(this.props.onClick)this.props.onClick();
    }
    render() {
        return (<Icon component={this.setIcon} onClick={()=>this.onClick()} />);
    }
}

export default IconE
